export default __webpack_public_path__ + "static/media/team-inactive.e40051c5.svg";